import { fg } from '@atlassian/jira-feature-gating';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';
import type { SelectedForm } from '../../types.tsx';
import type { FetchProformaFormDataParams, LinkedFields } from './types.tsx';
import { fetchProformaFormData, sendErrorAnalyticsEvent } from './utils.tsx';

export const fetchProformaSelectedForm = async ({
	cloudId,
	projectId,
	formId,
}: FetchProformaFormDataParams): Promise<SelectedForm | null> => {
	try {
		const proformaFormDataResponse: TemplateForm | null = await fetchProformaFormData({
			cloudId,
			projectId,
			formId,
		});

		if (proformaFormDataResponse === null) return null;
		const issueFormSettings = proformaFormDataResponse?.publish?.jira;
		return {
			formId,
			formName: proformaFormDataResponse?.design.settings.name,
			linkedFields: getLinkedFields(proformaFormDataResponse),
			usedAsIssueForm:
				(issueFormSettings?.newIssueRequestTypeIds &&
					issueFormSettings?.newIssueRequestTypeIds.length > 0) ||
				(issueFormSettings?.newIssueIssueTypeIds &&
					issueFormSettings?.newIssueIssueTypeIds.length > 0),
			restrictionStatus: fg('granular_permissions_on_forms_m1')
				? proformaFormDataResponse?.restrictionStatus
				: undefined,
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		sendErrorAnalyticsEvent(projectId, formId, error);
		return null;
	}
};

const getLinkedFields = (form: TemplateForm): LinkedFields =>
	Object.values(form.design.questions).reduce<LinkedFields>((acc, question) => {
		if (question.jiraField) {
			acc[question.jiraField] = {
				key: question.jiraField,
				required: question.validation.rq,
			};
		}
		return acc;
	}, {});
